
<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">创造自己的虚拟人物软件：成为虚拟世界的分身</h2>
                    <div class="time">2023-10-27 11:00:10</div>
                    <div class="start">
                        随着科技的发展，我们的生活变得越来越数字化。虚拟世界成为了一个新的社交空间，而虚拟人物成为了我们在这个世界中的代表。创造自己的虚拟人物变得越来越重要，而有了虚拟人物软件，这一切变得简单又有趣。
                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/253.png" alt="创造自己的虚拟人物软件：成为虚拟世界的分身" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t">
                        </div>
                        <div class="list-text">
                            虚拟人物的重要性 在虚拟世界中，你的虚拟人物是你的代表，它反映了你的个性、品味、爱好等。你可以通过它和别人交流、互动，甚至可以通过它进行游戏、工作等。因此，拥有一个独特的虚拟人物，不仅可以帮助你在虚拟世界中更好地表现自己，而且也可以让你的虚拟生活变得更加丰富多彩。
                        </div>
                        <div class="list-text">
                            虚拟人物软件的作用 虚拟人物软件可以帮助你轻松创造自己的虚拟人物。你可以选择人物的性别、肤色、发型、服装、配饰等，甚至可以调整人物的五官、身形等，让你的虚拟人物和你本人更加相似。有了虚拟人物软件，你可以轻松创造出自己的虚拟分身，不需要任何绘画或者3D建模的技能。
                        </div>
                        <div class="list-text">
                            虚拟人物软件的优势 虚拟人物软件有多个优势。
                        </div>
                        <div class="list-text">
                            简单易用：虚拟人物软件通常具有直观的用户界面，你可以轻松选择人物的各个部分，调整人物的参数，不需要任何专业技能。
                        </div>
                        <div class="list-text">
                            大量模板：虚拟人物软件通常提供大量的模板，你可以从中选择你喜欢的部分，组合成自己的虚拟人物。
                        </div>
                        <div class="list-text">
                            高度自定义：虚拟人物软件通常支持高度自定义，你可以调整人物的各个部分，甚至可以上传自己的图片，让你的虚拟人物更加独特。
                        </div>
                        <div class="list-text">
                            实时预览：虚拟人物软件通常支持实时预览，你可以在创建人物的过程中，随时查看人物的外观，方便你调整人物的参数。
                        </div>
                        <div class="list-text">
                            注意事项 虽然虚拟人物软件可以帮助你轻松创造自己的虚拟人物，但是也有一些需要注意的事项。
                        </div>
                        <div class="list-text">
                            尊重版权：虚拟人物软件可能提供了一些受版权保护的模板，你需要注意不要侵犯他人的版权。
                        </div>
                        <div class="list-text">
                            避免恶意使用：虚拟人物不仅可以用于正常的社交、游戏等，也可能被用于不正当的目的，例如欺诈、诽谤等。因此，在使用虚拟人物时，需要注意避免恶意使用。
                        </div>
                      

                    </div>
                    
                   


                    <div class="end">
                        总的来说，虚拟人物软件可以帮助你轻松创造自己的虚拟分身，让你在虚拟世界中更好地表现自己。不过，在使用虚拟人物时，也需要注意合法、合理、道德的使用。
                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "创造自己的虚拟人物软件：成为虚拟世界的分身-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "创造自己的虚拟人物软件：成为虚拟世界的分身,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "虚拟世界成为了一个新的社交空间，而虚拟人物成为了我们在这个世界中的代表",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo253.vue